import {
  actions,
  getCustomerGiftsAsync,
  getReceivedGiftsAsync,
} from './slices';

export const GiftsActions = {
  ...actions,
  getCustomerGiftsAsync,
  getReceivedGiftsAsync,
};
